import { type IDashboardServices } from './react';
import { type History } from 'history';
import { BrowserUrlService, BrowserUrlFactory, ReactRouterHistoryAdapter } from './urlService';
import { AbortControllerFactory } from './httpClient/AbortControllerFactory';
import { AxiosHttpClientFactory } from './httpClient/AxiosHttpClientFactory';
import { httpClient as legacyHttpClient } from 'shared/http-client';
import { BrowserScreenshotService } from './screenshotService';
import { BrowserImageFactory } from './imageService';
import { HeadersGetter } from './httpClient/IHttpClientConfig';
import { ServerSentEventsFactoryCreator } from './serverSentEventsService/ServerSentEventsFactoryCreator';
import { BrowserTitleClient, TitleService } from './titleService';
import { SessionValidatorService } from './session-validator-service/SessionValidatorService';
import { getAppGatewayEndpoint } from 'core/default-endpoint-url';
import { ISessionValidatorService } from './session-validator-service/ISessionValidatorService';

export function createBrowserDashboardServices(history: History): Required<IDashboardServices> {
    const headersGetter: HeadersGetter = () => {
        return {
            // @ts-ignore
            Authorization: `Token ${legacyHttpClient.token}`,
        };
    };
    const titleClient = new BrowserTitleClient();
    const apiGatewayEndpoint = getAppGatewayEndpoint();

    const httpClientFactory = new AxiosHttpClientFactory(headersGetter);
    const imageFactory = new BrowserImageFactory();
    const screenshotService = new BrowserScreenshotService(imageFactory);
    const urlFactory = new BrowserUrlFactory();
    const historyAdapter = new ReactRouterHistoryAdapter(history);
    const urlService = new BrowserUrlService(urlFactory, historyAdapter);
    const abortControllerFactory = new AbortControllerFactory();
    const serverSentEventsFactoryCreator = new ServerSentEventsFactoryCreator(
        urlService,
        abortControllerFactory,
        headersGetter,
    );
    const titleService = new TitleService(titleClient, ['Placer'], ' - ');
    const httpClient = httpClientFactory.createClientWithBaseUrl(apiGatewayEndpoint);
    const sessionValidatorService: ISessionValidatorService = new SessionValidatorService(
        httpClient,
    );

    return {
        urlService,
        httpClientFactory,
        abortControllerFactory,
        screenshotService,
        imageFactory,
        serverSentEventsFactoryCreator,
        titleService,
        sessionValidatorService,
    };
}
